import { BackToTopComponent, FooterComponent, HeaderComponent, WhatsAppFabComponent } from './layout';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AuthModalComponent } from './features/auth/components/auth-modal/auth-modal.component';
import { CartDrawerComponent } from './features/cart/cart-drawer/cart-drawer.component';
import { CompareBarComponent } from './shared/ui/compare-bar/compare-bar.component';
import { EarlyAccessBlockedDialogComponent } from './shared/ui/early-access-blocked-dialog/early-access-blocked-dialog.component';
import { EventDialogComponent } from './features/events/components/event-dialog/event-dialog.component';
import { EventDialogService } from './features/events/data/event-dialog.service';
import { PerronPointsModalComponent } from './shared/ui/perron-points-modal/perron-points-modal.component';
import { PrepurchaseModalComponent } from './shared/ui/prepurchase-modal/prepurchase-modal.component';
import { NewsletterPopupComponent } from './shared/ui/newsletter-popup/newsletter-popup.component';
import { ProcessingOverlayComponent } from './shared/ui/processing-overlay/processing-overlay.component';
import { RouterOutlet } from '@angular/router';
import { SearchOverlayComponent } from './features/search/ui/search-overlay/search-overlay.component';
import { StockAlertModalComponent } from './shared/ui/stock-alert-modal/stock-alert-modal.component';
import { ToastStackComponent } from './shared/ui/toast-stack/toast-stack.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    WhatsAppFabComponent,
    BackToTopComponent,
    AuthModalComponent,
    CartDrawerComponent,
    CompareBarComponent,
    PrepurchaseModalComponent,
    StockAlertModalComponent,
    PerronPointsModalComponent,
    EarlyAccessBlockedDialogComponent,
    SearchOverlayComponent,
    NewsletterPopupComponent,
    EventDialogComponent,
    ToastStackComponent,
    ProcessingOverlayComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  /** Solo para el `@defer (when …)` del diálogo de eventos: el servicio es ligero a propósito. */
  protected readonly eventDialog = inject(EventDialogService);

  protected readonly whatsappUrl =
    'https://wa.me/50689125220?text=¡Hola!%2C%20Tengo%20la%20siguiente%20consulta%20sobre%20productos%20de%20PerronStore%3A';
}
